/// <reference path="../include.ts" />

module gpx_visualizer_phase2 {

	export class ControllerTerrainTypeEvent extends alm.event.Event {

		public static CHANGE:string = 'ControllerTerrainTypeEvent.CHANGE';





		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(eventType:string, target:object) {
			super(eventType, target);
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------
	}
}
